import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IFacility } from "../facilityModal";

export const getAllFacilities = createAsyncThunk(
  "Facilities/FindAllFacilities",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facilities/FindAllFacilities`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createFacility = createAsyncThunk(
  "Facilities/InsertFacilities",
  async (FacilityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facilities/InsertFacilities`,
        FacilityData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateFacility = createAsyncThunk(
  "Facilities/UpdateFacilities",
  async (FacilityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facilities/UpdateFacilities`,
        FacilityData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteFacility = createAsyncThunk(
  "Facilities/DeleteFacilities",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facilities/DeleteFacilities`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Facility :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFacilityByID = createAsyncThunk(
  "Facilities/FindByIDFacilities",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facilities/FindByIDFacilities`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        // Image: result.Image,
        // Description: result.Description,
        IsActive: result.IsActive ? 1 : 2,
      } as IFacility;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveFacility = createAsyncThunk(
  "Facilities/FindAllActiveFacilities",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Facilities/FindAllActiveFacilities`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveFacility = createAsyncThunk(
  "Facilities/ActiveInActiveFacilities",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facilities/ActiveInActiveFacilities`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Facility :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

// export const FacilityImageUpload = createAsyncThunk(
//   "Facility/FacilityImageUpdate",
//   async (formData: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/Facility/FacilityImageUpdate`,
//         formData,
//         {
//           headers: { "content-type": "multipart/form-data" },
//         },
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error upload Facility Image :", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   },
// );
